import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutFocusSetResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutFocusSetResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutFocusSetResponse) {
    JsonSchemaValidator.assert(
      RoomStageLayoutFocusSetResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStageLayoutFocusSetResponseJson {
  roomId: RoomId;
  streamId: StreamId;
}

interface RoomStageLayoutFocusSetResponse {
  roomId: RoomId;
  streamId: StreamId;
}
